import React from 'react'
import { Layout } from 'antd'

const Footer = () => (
  <Layout.Footer style={{ textAlign: 'center' }}>
    Tracking ©2018 Created by Thai.run
  </Layout.Footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js